/*
 dhtmlxGantt Persian (Farsi, fa_IR) locale by Mohammad Shokri http://slashsbin.com/
 */
/*jshint -W100*/
gantt.locale = {
	date:{
		month_full:[
			"ژانویه",
			"فوریه",
			"مارس",
			"آوریل",
			"مه",
			"ژوئن",
			"ژوئیه",
			"اوت",
			"سپتامبر",
			"اکتبر",
			"نوامبر",
			"دسامبر"
		],
		month_short:[ "1","2","3","4","5","6","7","8","9","10","11","12" ],
		day_full:[
			"يکشنبه",
			"دوشنبه",
			"سه‌شنبه",
			"چهارشنبه",
			"پنجشنبه",
			"جمعه",
			"شنبه"
		],
		day_short:[
			"ی",
			"د",
			"س",
			"چ",
			"پ",
			"ج",
			"ش"
		]
	},
	labels:{
		new_task:"وظیفه جدید",
		new_event: "رویداد جدید",
		icon_save:"ذخیره",
		icon_cancel:"لغو",
		icon_details:"جزییات",
		icon_edit:"ویرایش",
		icon_delete:"حذف",
		confirm_closing:"تغییرات شما ازدست خواهد رفت، آیا مطمئن هستید؟",
		confirm_deleting:"این مورد برای همیشه حذف خواهد شد، آیا مطمئن هستید؟",
		section_description:"توضیحات",
		section_time:"مدت زمان",
		section_type:"نوع",

		/* grid columns */

		column_wbs : "WBS",
		column_text : "عنوان",
		column_start_date : "زمان شروع",
		column_duration : "مدت",
		column_add : "",

		/* link confirmation */
		link: "ارتباط",
		confirm_link_deleting:"حذف خواهد شد",
		link_start: " (آغاز)",
		link_end: " (پایان)",

		type_task: "وظیفه",
		type_project: "پروژه",
		type_milestone: "نگارش",

		minutes: "دقایق",
		hours: "ساعات",
		days: "روزها",
		weeks: "هفته",
		months: "ماه‌ها",
		years: "سال‌ها",

		/* message popup */
		message_ok: "تایید",
		message_cancel: "لغو"

	}
};




//////////////////
// WEBPACK FOOTER
// ./sources/locale/locale_fa.js
// module id = 21
// module chunks = 21